export function getTelLinkFromPhone(phone) {
  return "tel:+55" + phone.replace(/[^0-9]/g, "");
}
